import type { Control } from "react-hook-form";
import type { Person } from "../../../../utils/backend-types";
import { type applyHighlightingToObjectFormFieldData } from "../../../../utils/react-hook-form/applyHighlightingToObjectFormFieldData";
import { FormFieldController } from "../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { type PERSON_FORM_FIELD_DATA } from "../PersonForm.constants";

interface EditFieldsProps {
  control: Control<Person>;
  formFieldData: ReturnType<
    typeof applyHighlightingToObjectFormFieldData<
      Person,
      typeof PERSON_FORM_FIELD_DATA
    >
  >["formFieldData"];
}

interface RegulatoryDutiesFieldsProps extends EditFieldsProps {
  isManufacturingCompany: boolean;
  showEigenerzeugungPlusFields: boolean;
  showSmallMediumEnterpriseField: boolean;
}

function RegulatoryDutiesFields({
  control,
  formFieldData,
  isManufacturingCompany,
  showEigenerzeugungPlusFields,
  showSmallMediumEnterpriseField
}: RegulatoryDutiesFieldsProps) {
  return (
    <>
      {showEigenerzeugungPlusFields && (
        <>
          <FormFieldController
            control={control}
            data={formFieldData.manufacturingIndustry}
          />
          <FormFieldController
            control={control}
            data={formFieldData.forestryOrAgriculture}
          />
          {isManufacturingCompany && (
            <FormFieldController
              control={control}
              data={
                formFieldData.electricityOrEnergyTaxRelief_10StromstgOr_55Energiestg
              }
            />
          )}
          <FormFieldController
            control={control}
            data={formFieldData.dinEnIso_50001Installed}
          />
          <FormFieldController
            control={control}
            data={formFieldData.emasInstalled}
          />
          <FormFieldController
            control={control}
            data={formFieldData.dinEn16247_1Installed}
          />
          {isManufacturingCompany && (
            <FormFieldController
              control={control}
              data={formFieldData.energyTaxRelief_54Energiestg}
            />
          )}
          {isManufacturingCompany && (
            <FormFieldController
              control={control}
              data={formFieldData.energyTaxRelief_51Energiestg}
            />
          )}
          <FormFieldController
            control={control}
            data={formFieldData.isYearlyReportOfTaxReliefsRequired}
          />
        </>
      )}

      {showEigenerzeugungPlusFields && (
        <>
          <FormFieldController
            control={control}
            data={formFieldData.makesUseOfExemptsOver_500_000PerYear}
          />
          <FormFieldController
            control={control}
            data={formFieldData.electricityConsumptionOver_50GwhPerYear}
          />
          <FormFieldController
            control={control}
            data={formFieldData.makesUseOfBesondereAusgleichsregelung}
          />
          <FormFieldController
            control={control}
            data={formFieldData.makesUseOfBeihilfenStrompreiskompensation}
          />
        </>
      )}

      {showSmallMediumEnterpriseField && (
        <FormFieldController
          control={control}
          data={formFieldData.smallMediumEnterprise}
        />
      )}
    </>
  );
}

export { RegulatoryDutiesFields, type RegulatoryDutiesFieldsProps };
